import { formatCivilRangeLabel, getCivilMonthRange, isValidCivilDate } from '../domain/finance';

export const isValidMovementRange = (startDate, endDate) => (
  isValidCivilDate(startDate) && isValidCivilDate(endDate) && startDate <= endDate
);

// The URL owns temporal scope; content filters never change its boundaries.
export const getMovementTemporalContext = (params, selectedPeriod, futureRange) => {
  if (params.get('view') === 'future') return { mode: 'future', range: futureRange, title: 'Próximos 30 dias', flowTitle: 'Fluxo dos próximos 30 dias' };
  if (params.get('view') === 'recent') return { mode: 'recent', range: null, title: 'Movimentações recentes', flowTitle: 'Fluxo do histórico recente' };
  if (params.get('view') === 'all') return { mode: 'all', range: null, title: 'Todas as movimentações', flowTitle: 'Fluxo geral' };
  if (params.has('start') || params.has('end')) {
    const startDate = params.get('start') || '';
    const endDate = params.get('end') || '';
    const valid = isValidMovementRange(startDate, endDate);
    return {
      mode: 'range', range: valid ? { startDate, endDate } : null,
      title: 'Período personalizado', flowTitle: 'Fluxo do período',
      error: valid ? null : new Error('INVALID_MOVEMENT_RANGE'),
    };
  }
  return { mode: 'month', range: getCivilMonthRange(selectedPeriod), flowTitle: 'Fluxo do mês' };
};

export const withMovementTemporalContext = (params, { mode, startDate, endDate }) => {
  if (mode === 'range' && !isValidMovementRange(startDate, endDate)) throw new Error('INVALID_MOVEMENT_RANGE');
  const next = new URLSearchParams(params);
  ['view', 'start', 'end', 'edit'].forEach((key) => next.delete(key));
  if (mode === 'all') next.set('view', 'all');
  if (mode === 'range') {
    next.set('start', startDate);
    next.set('end', endDate);
  }
  return next;
};

export const formatMovementRangeLabel = (range, includeYear = false) => {
  if (!range) return '';
  const label = formatCivilRangeLabel(range.startDate, range.endDate);
  return includeYear && range.startDate.slice(0, 4) === range.endDate.slice(0, 4)
    ? label + ' ' + range.endDate.slice(0, 4)
    : label;
};
